const ALL_SHIFTS = [1, 2, 3, 4];

/**
 * Smene iz zajedničke trake/zaglavlja za ekran koji nasleđuje stari tab sa podatkom `shifts` (zato smene ne
 * mogu biti prop istog imena): stižu u $attrs.shifts i upisuju se u `selectedShifts` starog taba.
 * Prati se string (`barShiftsKey`), a ne niz: u Vue 2 posmatrač niza okida pri svakom ažuriranju $attrs čak i
 * kad je niz isti, pa bi izbor smena i brojke roditelja pravili beskonačnu petlju.
 */
export default {
  inheritAttrs: false,
  computed: {
    barShiftsKey() {
      return (Array.isArray(this.$attrs.shifts) ? this.$attrs.shifts : ALL_SHIFTS).join(",");
    },
  },
  watch: {
    barShiftsKey: {
      handler(key) {
        this.selectedShifts = key ? key.split(",").map(Number) : [];
      },
      immediate: true,
    },
  },
};
